// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"604":"5ccdb6ef","960":"9471bb16","991":"5672662f"}[chunkId] + ".chunk.css";
};